import React from 'react';
import '../../css/vers2/HeroSection.css';

type HeroSectionProps = {
    setPage: React.Dispatch<React.SetStateAction<string>>;
};

const HeroSection = ({ setPage }: HeroSectionProps) => {
    return (
        <section id="home" className="hero-section page-section">
            <div className="hero-shape hero-yellow">
                <svg viewBox="0 0 620 440" preserveAspectRatio="none">
                    <path
                        d="M 0 0 L 620 0 L 620 440 C 520 440 470 390 455 340 C 440 290 420 260 360 270 C 300 280 280 240 290 190 C 300 130 240 110 180 105 C 120 100 60 70 0 0 Z"
                        fill="#ffd35a"
                    />
                </svg>
            </div>
            <div className="hero-shape hero-green">
                <svg viewBox="0 0 620 420" preserveAspectRatio="none">
                    <path
                        d="M 0 0 C 100 0 140 40 180 120 C 210 200 250 240 330 235 C 460 230 560 300 620 420 L 0 420 Z"
                        fill="#77a94b"
                    />
                </svg>
            </div>

            <div className="hero-blob hero-blob-yellow-left">
                <svg viewBox="0 0 120 80">
                    <path d="M4 76C16 28 42 4 80 10C115 15 128 48 98 64C75 77 35 61 4 76Z" />
                </svg>
            </div>

            <div className="hero-blob hero-blob-red-left">
                <svg viewBox="0 0 90 140">
                    <path d="M14 2C25 42 72 49 79 91C86 129 45 151 18 122C-5 96 3 45 14 2Z" />
                </svg>
            </div>

            <div className="hero-blob hero-blob-blue-top">
                <svg viewBox="0 0 130 80">
                    <path d="M5 70C22 28 61 -1 98 9C128 18 137 50 108 68C83 84 51 55 5 70Z" />
                </svg>
            </div>

            <div className="hero-blob hero-blob-red-dot"></div>
            <div className="hero-blob hero-blob-yellow-dot"></div>
            <div className="hero-blob hero-blob-blue-dot"></div>

            <div className="hero-blob hero-blob-orange-right">
                <svg viewBox="0 0 130 95">
                    <path d="M124 4C114 54 85 92 41 90C8 89 -7 60 15 35C43 4 83 28 124 4Z" />
                </svg>
            </div>

            <div className="hero-content">
                <p className="hero-small-title">GASTOUDEROPVANG</p>
                <h1>CIJNTJE</h1>

                <div className="hero-buttons">
                    <button
                        type="button"
                        className="btn btn-blue"
                        onClick={() => setPage('about')}
                    >
                        Lees meer
                        <span className="btn-arrow"></span>
                    </button>
                    {/*<a href="#contact" className="btn btn-yellow">Contact</a>*/}
                </div>
            </div>
        </section>
    );
};

export default HeroSection;